export default "__VITE_ASSET__5e23d150__"